<script setup lang="ts">
import Extension from "@/core/interfaces/extension/Extension";
import {computed} from "vue";
import LaboratoryExtensionCard from "@/laboratory/components/LaboratoryExtensionCard.vue";

const props = defineProps<{
    extensions: Extension[];
}>();

const programLabel = computed(() => {
    return props.extensions.map((extension) => extension.name).join(", ");
});
</script>

<template>
  <div class="bg-white rounded-md p-4 shadow-2xl space-y-6">
    <div class="flex-1">
      <h1 class="text-black font-content-bold">
        Augmentez les ventes au comptoir
      </h1>
      <p>Découvrez nos programmes d'accompagnement patient {{ programLabel }}</p>
    </div>
    <div class="flex flex-row flex-wrap gap-3 items-start">
      <LaboratoryExtensionCard
        v-for="extension in extensions"
        :key="extension.id"
        :extension="extension"
      />
    </div>
  </div>
</template>

<style scoped>

</style>
